export default function AddIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6H11V11H6V13H11V18H13V13H18V11H13V6Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
